import { ChangeDetectorRef, Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-welcome',
  imports: [TranslatePipe],
  templateUrl: './welcome.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './welcome.scss'
})
export class Welcome {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly route = inject(ActivatedRoute);
  webDomain = signal<string>('');
  currentLang = signal<string>(this.route.snapshot.paramMap.get('lang') || 'en-US');
  adminUrl = signal<string>('');
  constructor() {
    const raw = this.route.snapshot.queryParamMap.get('webDomain') || '';
    const domain = raw ? decodeURIComponent(raw) : '';
    if (domain) {
      this.webDomain.set(domain);
    }
    const lang = this.route.snapshot.paramMap.get('lang') || '';
    if (lang) {
      this.currentLang.set(lang);
    }

    this.adminUrl.set(`${this.webDomain()}/${this.currentLang()}/admin`);
  }

}
